export default __webpack_public_path__ + "static/media/0103.10384d42.jpg";